import { ActionTree } from 'vuex';
import { Campus, City, LocationState } from './state';
import RootState from '@/store/root_state';
import {
  AllCampusQueryResult,
  AllCitiesQueryResult,
  allCampus,
  allCities,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import { UpsertAdmissionMutationInput } from '@/store/graphql/mutations/westerosAdmissionsMutations';

const actions: ActionTree<LocationState, RootState> = {
  UPDATE_CITY({ commit }, payload: { city: City }) {
    const { city } = payload;

    commit('SET_CITY', city);
    commit('SET_AVAILABLE_CAMPUSES', []);
  },
  async UPDATE_CAMPUS({ dispatch }, payload: { campus: Campus }): Promise<void> {
    const { campus } = payload;

    const params: UpsertAdmissionMutationInput = { campusId: campus.id };

    await dispatch('UPSERT_ADMISSION', params);
  },
  async PULL_AVAILABLE_CITIES({ commit, state }): Promise<void> {
    const { availableCities } = state;
    if (availableCities.length > 0) return;

    const { data } = await query<AllCitiesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCities,
      undefined,
      true,
    );

    const cities: City[] = data.allCities;

    commit(
      'SET_AVAILABLE_CITIES',
      cities.sort(({ city: city1 = '' }, { city: city2 = '' }) => city1.localeCompare(city2)),
    );
  },
  async PULL_AVAILABLE_CAMPUSES({ commit, state }): Promise<void> {
    const { city } = state;

    const { data } = await query<AllCampusQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCampus,
      {
        city: city?.city,
        state: city?.state,
        isAvailable: true,
      },
      true,
    );

    const campuses: Campus[] = data.allCampus;

    commit(
      'SET_AVAILABLE_CAMPUSES',
      campuses.sort(({ name: name1 = '' }, { name: name2 = '' }) => name1.localeCompare(name2)),
    );
  },
};

export default actions;
